<template>
  <div class="container">
    <head-nav-bar title="科室介绍" :fixed="true" />
    <div class="mt-header-nav">
      <DataList api="Department_List">
        <template v-slot:item="item">
          <news-card
            :data="item.obj"
            isKeShi
            titleField="name"
            descField="introduction"
            @click="toInfo(item.obj)"
          />
        </template>
      </DataList>
    </div>
  </div>
</template>

<script>
import DataList from "@/components/DataList";
import NewsCard from "@/components/NewsCard";

export default {
  components: {
    DataList,
    NewsCard
  },
  data() {
    return {
      info: {}
    };
  },
  created() {},
  methods: {
    toInfo(item) {
      this.$router.push({
        name: "hospitalDepartmentInfo",
        query: {
          Id: item.id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
